export function scrollToTop(el, extraPadding = 100) {
  if (!el || typeof el.getBoundingClientRect !== 'function') {
    return;
  }

  const header = document.querySelector('.top-bar');
  const headerHeight = header ? header.getBoundingClientRect().height : 0;

  el.scrollIntoView({ block: 'start' });

  if (header) {
    const adjustedTop = el.getBoundingClientRect().top;

    if (adjustedTop < headerHeight) {
      window.scrollBy({
        top: -(headerHeight - adjustedTop + extraPadding),
        left: 0,
        behavior: 'instant',
      });
    }
  }
}
